(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/tickets-table/components/sum.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/tickets-table/components/sum.js');
"use strict";


const _svs$ticket_partner$c = svs.ticket_partner.constants.copy.TICKETS_TABLE.SUM,
  SUM = _svs$ticket_partner$c.SUM,
  SEK = _svs$ticket_partner$c.SEK;
const _svs$ui$reactTable = svs.ui.reactTable,
  TableRow = _svs$ui$reactTable.TableRow,
  TableCell = _svs$ui$reactTable.TableCell;
const Sum = _ref => {
  let articles = _ref.articles;
  const sumOfArticles = _.values(articles).reduce((acc, currentArticle) => acc + currentArticle.count * currentArticle.price, 0) || 0;
  return React.createElement(TableRow, {
    footer: true
  }, React.createElement(TableCell, {
    className: "sum-align",
    colspan: "4"
  }, React.createElement("span", {
    className: "f-bold"
  }, SUM, "\xA0", svs.utils.format.Currency(sumOfArticles), "\xA0", SEK)));
};
svs.ticket_partner.sharedComponents.ticketsTable.components.Sum = Sum;

 })(window);